export const assortmentSimulationDetailEs = {
  backToSimulations: "Volver a Simulaciones",
  majorSimulation: "Simulacion Mayor",
  minorSimulation: "Simulacion Menor",
  lastUpdated: "Ultima actualizacion",
  export: "Exportar",
  saveChanges: "Guardar Cambios",
  update: "Actualizar",

  assortment: {
    title: "Surtido",
    activeProducts: "productos activos",
    ai: "IA",
    manual: "Manual",
    added: "Agregados",
    removed: "Eliminados",
    addProduct: "Agregar Producto",
    sourcePog: "Datos de Planograma",
    sourcePerformance: "Datos de Rendimiento",
    sourceRecommendationsOnly: "Solo Recomendaciones",
    segmentation: "Segmentación",
  },

  segmentLevel: {
    General: "General",
    Store: "Tienda",
    Cluster: "Cluster",
    "Cluster Category": "Cluster Categoría",
    "Cluster Institucional": "Cluster Institucional",
    "Cluster Institutional": "Cluster Institucional",
    store: "Tienda",
    cluster: "Cluster Institucional",
    "cluster-category": "Cluster Categoría",
    general: "General",
    country: "País",
  },

  search: {
    placeholder: "Buscar productos",
  },

  filters: {
    allClusters: "Todos los Clusters",
    allCatClusters: "Todos Clusters Cat.",
    allInstClusters: "Todos Clusters Inst.",
    allStores: "Todas las Tiendas",
    allOrigins: "Todos los Origenes",
    allStatus: "Todos los Estados",
    existing: "Existente",
    new: "Nuevo",
  },

  table: {
    product: "Producto",
    cluster: "Cluster",
    catCluster: "Cluster Cat.",
    instCluster: "Cluster Inst.",
    store: "Tienda",
    cpiScoreRank: "CPI Score & Rank",
    projectedSales: "Ventas Proyectadas",
    score: "Puntaje",
    origin: "Origen",
    status: "Estado",
    actions: "Acciones",
    view: "Ver",
    restore: "Restaurar",
    active: "Activo",
  },

  comparison: {
    title: "Comparacion Antes y Despues",
    subtitle: "Comparacion de metricas clave de rendimiento",
    metric: "Metrica",
    before: "Antes",
    after: "Despues",
    change: "Cambio",
  },

  space: {
    title: "Utilizacion de Espacio del Planograma",
    subtitle: "Asignacion de espacio lineal por",
    subcategory: "Subcategoria",
    brand: "Marca",
    status: "Estado",
    statusExisting: "Existente",
    statusNew: "Nuevo",
    statusAvailable: "Disponible",
    statusRemoved: "Removido",
    totalLinearSpace: "Espacio lineal total",
    nearCapacity: "Cerca de capacidad",
    highUtilization: "Alta utilizacion",
    availableSpace: "Espacio disponible",
    free: "libre",
    noData: "No hay datos de espacio disponibles para la selección actual",
  },

  addModal: {
    title: "Agregar Producto al Surtido",
    subtitle: "Seleccione productos del catalogo para agregar a esta simulacion",
    searchPlaceholder: "Buscar productos disponibles",
    add: "Agregar",
    close: "Cerrar",
    noProducts: "No hay productos disponibles",
    noProductsSearch: "Ningun producto coincide con su busqueda.",
    noProductsAll: "Todos los productos han sido agregados al surtido.",
    score: "Puntaje",
    projectedSales: "Ventas Proyectadas",
    selectStorePlaceholder: "Seleccione una tienda...",
    filters: {
      allSubcategories: "Todas las subcategorías",
      allBrands: "Todas las marcas",
      allSegments: "Todos los segmentos",
    },
    tooltip: {
      sku: "SKU",
      cpi: "CPI",
      projectedImpact: "Impacto proyectado",
      subcategory: "Subcategoría",
      brand: "Marca",
      segment: "Segmento",
      size: "Tamaño",
      width: "Ancho",
    },
  },

  rowTooltip: {
    sku: "SKU",
    fsi: "FSI",
    cpi: "CPI",
    space: "Espacio",
    projectedImpact: "Impacto proyectado",
    width: "Ancho",
    subcategory: "Subcategoría",
    brand: "Marca",
    segment: "Segmento",
    size: "Tamaño",
  },

  detailModal: {
    segment: "Segmento",
    source: "Origen",
    salesAmount: "Ventas",
    unitsLabel: "Unidades",
    daysOnHand: "Dias de Inventario",
    cpiAndFsi: "CPI {{cpi}}, FSI {{fsi}}",
    overallScore: "Puntaje General",
    projectedSales: "Ventas Proyectadas",
    linearSpace: "Espacio Lineal",
    rotation: "Rotacion",
    margin: "Margen",
    historicalSales: "Ventas Historicas",
    complementarity: "Complementariedad",
    trend: "Tendencia",
    performanceMetrics: "Metricas de Rendimiento",
    newlyAdded: "Recien Agregado",
    removedFromAssortment: "Eliminado del Surtido",
    existingProduct: "Producto Existente",
    removeFromAssortment: "Eliminar del Surtido",
    close: "Cerrar",
    reason: "Razon",
  },
} as const;
